<style lang="scss">
    .popper {
        font-size: 0.9em;
    }

    .popper .popper__arrow {
        border-top-color: #000 !important;
    }

    .disable-pointer {
        pointer-events: none
    }
</style>

<template>
    <div>
        <label for="role" class="required">Which best describes you?</label>
        <div v-if="disabled" class="popper alert alert-warning" role="alert">
            You have been invited to register as a <strong>{{ role }}</strong>. If you feel that is incorrect, please contact your state Go NAPSACC representative.
        </div>

        <select :class="{'disable-pointer': disabled}" v-model="selected" class="form-control" id="role" name="role" :disabled="disabled">
            <option value="">Choose One</option>
            <option value="ta-consultant">I provide technical assistance to child care programs</option>
            <option value="partner-user">I manage technical assistance providers and/or the implementation of Go NAPSACC in my area</option>
        </select>

        <div class="small">Role cannot be changed after registration.</div>
        <span class="error-message" v-for="error in errors['role']">
            <strong>{{ error }}</strong>
        </span>
    </div>
</template>


<script>
    export default {
        props: {
            'userRole': {
                type: String,
                default: ''
            },
            'errors': {
                type: Object
            }
        },
        components: {
        },
        data() {
            return {
                selected: '', // value of option
                currentRole: ''
            }
        },
        computed: {
            role() {
                let role = "";

                switch(this.userRole) {
                    case 'ta-consultant':
                        role = "TA Consultant";
                        break;
                    case 'partner-user':
                        role = "State Administrator";
                        break;
                    default:
                        role = "";
                        break;
                }

                return role;
            },
            disabled() {
                return this.userRole.length > 0;
            }
        },
        mounted() {
            this.selected = this.userRole; 
            this.currentRole = this.userRole;
        }
    }
</script>
